/**
 * @fileoverview Modal component for viewing production order target details
 * Displays production order target (output batch) information in a read-only view
 */
import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { intl, fetchData, HTTP_STATUS } from "dmsbasereact";
import { DmsDetailModal } from "../../DmsDetailModal";
import { ViewModeContent } from "./ViewModeContent";

/**
 * Modal for viewing production order target details (read-only)
 */
export const ProductionOrderTargetDetailModal = ({
  open,
  onClose,
  target = null,
}) => {
  const [loading, setLoading] = useState(false);
  const [enrichedTarget, setEnrichedTarget] = useState(null);

  // Load additional target data if needed
  const loadAdditionalData = useCallback(async (targetData) => {
    if (!targetData) return null;

    try {
      // Fetch full production order target details
      const response = await fetchData(
        `/production_order_target/${targetData.pk}`,
        "GET",
        true
      );
      
      if (response.status === HTTP_STATUS.OK_200 && response.data?.data) {
        return response.data.data;
      }
    } catch (error) {
      console.error("Error loading production order target details:", error);
    }

    return targetData;
  }, []);

  // Load data when modal opens or target changes
  useEffect(() => {
    if (open && target) {
      setLoading(true);
      loadAdditionalData(target).then((enriched) => {
        setEnrichedTarget(enriched);
        setLoading(false);
      });
    } else if (!open) {
      setEnrichedTarget(null);
    }
  }, [open, target, loadAdditionalData]);

  return (
    <DmsDetailModal
      open={open}
      onClose={onClose}
      data={enrichedTarget}
      loading={loading}
      title={{
        view: intl.get("ProductionOrderTargetDetails").d("Production Output Details"),
      }}
      viewContent={ViewModeContent}
      canEdit={false}
    />
  );
};

ProductionOrderTargetDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  target: PropTypes.object,
};

